var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepIconLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "step-icon-left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,5.0001 C11.448,5.0001 11,4.5521 11,4.0001 L11,1.0001 C11,0.4481 11.448,0.0001 12,0.0001 C12.552,0.0001 13,0.4481 13,1.0001 L13,4.0001 C13,4.5521 12.552,5.0001 12,5.0001 Z M4.0029,12.9972 L1.0029,12.9972 C0.4509,12.9972 0.0029,12.5492 0.0029,11.9972 C0.0029,11.4452 0.4509,10.9972 1.0029,10.9972 L4.0029,10.9972 C4.5549,10.9972 5.0029,11.4452 5.0029,11.9972 C5.0029,12.5492 4.5549,12.9972 4.0029,12.9972 Z M22.9971,12.9972 L19.9971,12.9972 C19.4451,12.9972 18.9971,12.5492 18.9971,11.9972 C18.9971,11.4452 19.4451,10.9972 19.9971,10.9972 L22.9971,10.9972 C23.5491,10.9972 23.9971,11.4452 23.9971,11.9972 C23.9971,12.5492 23.5491,12.9972 22.9971,12.9972 Z M7.0522,7.0494 C6.6612,7.4404 6.0282,7.4404 5.6382,7.0494 L3.5162,4.9274 C3.1262,4.5374 3.1262,3.9044 3.5162,3.5134 C3.9072,3.1234 4.5402,3.1234 4.9312,3.5134 L7.0522,5.6354 C7.4432,6.0254 7.4432,6.6584 7.0522,7.0494 Z M16.9478,7.0499 C16.5568,6.6589 16.5568,6.0259 16.9478,5.6349 L19.0698,3.5139 C19.4598,3.1239 20.0928,3.1239 20.4838,3.5139 C20.8738,3.9049 20.8738,4.5379 20.4838,4.9279 L18.3628,7.0499 C17.9718,7.4399 17.3388,7.4399 16.9478,7.0499 Z M14.3188,15.254 C15.3718,14.503 15.9998,13.287 15.9998,12 C15.9998,9.795 14.2058,8 11.9998,8 C9.7948,8 7.9998,9.795 7.9998,12 C7.9998,13.298 8.6368,14.52 9.7038,15.27 C10.5268,15.848 10.9998,16.722 10.9998,17.667 L10.9998,18 L12.9998,18 L12.9998,17.732 C12.9998,16.754 13.4808,15.852 14.3188,15.254 Z M10.9998,21 L12.9998,21 L12.9998,20 L10.9998,20 L10.9998,21 Z M11.9998,6 C15.3088,6 17.9998,8.692 17.9998,12 C17.9998,13.932 17.0578,15.757 15.4798,16.882 C15.1748,17.1 14.9998,17.409 14.9998,17.732 L14.9998,18 L14.9998,20 L14.9998,21 C14.9998,22.103 14.1028,23 12.9998,23 L10.9998,23 C9.8968,23 8.9998,22.103 8.9998,21 L8.9998,20 L8.9998,18 L8.9998,17.667 C8.9998,17.382 8.8378,17.105 8.5538,16.906 C6.9548,15.783 5.9998,13.949 5.9998,12 C5.9998,8.692 8.6918,6 11.9998,6 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Widget-/-Help-/-Icon-/-Regular",
    transform: "translate(-28.000000, -28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Padding-Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icono-/-L-/-Margin-/-BG-/-Seguro",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFC900",
    fillRule: "evenodd",
    cx: 24,
    cy: 24,
    r: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icono-/-Idea",
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Black-/-800",
    mask: "url(#mask-2)",
    fill: "#444444",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepIconLeft);
export default __webpack_public_path__ + "static/media/step-icon-left.ebeb5c3a5dad75c05c4082bec0bb609e.svg";
export { ForwardRef as ReactComponent };